import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const fetchManagedOfferContent: DocumentNode = gql`
  query FetchManagedOfferContent($storyId: String!, $version: String!, $relations: String) {
    fetchManagedContent: fetchManagedOfferContent(storyId: $storyId, version: $version, relations: $relations) {
      ... on ManagedOfferContent {
        cv
        story {
          slug
          content {
            component
            contentSections
            ctaText
            headerImage
            headerTitle
          }
        }
        rels
      }
    }
  }
`

export default fetchManagedOfferContent
